(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-template"]) return;
  try {
    

 $(document).ready(function(){

   /* var parent = $('li.site-nav--active').parent();
    var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

  });  
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

  $(function () {
    $('.toggle-filters').magnificPopup({
      type: 'inline',
      preloader: false,
      focus: '#username',
      modal: true
    });
    $(document).on('click', '.mfp-close', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
    });
  });
function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
      newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  }

  $('.changes-view').on('click', function() {

  
    var view = $(this).data('view'),
        url = document.URL,
        hasParams = url.indexOf('?') > -1;
    var current_url = window.location.href.split('?')[0];
    if (hasParams) {
      window.location = replaceUrlParam(current_url, 'view', view);
    } else {
      window.location = url + '?view=' + view;
    }
  });
    document.addEventListener("DOMContentLoaded", function() {
    var endlessClick = new Ajaxinate({
      method: 'click'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    

  
  
  $('.owlgrid').owlCarousel({
    loop:false,
   
    dots:false,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        480:{
            items:2,
            nav:true,
            margin:15
        },
        680:{
            items:3,
            nav:true,
            margin:15
        },
        1000:{
            items:4,
            nav:true,
            loop:true,
			margin:15

        }
    }


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

$(".status").click(function(){
    $(".cart-details").toggle();
});

$(".site-nav__link--button").click(function(){
    $(this).next().toggle();
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-clothing"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ems-medical"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-fire-rescue"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hiviz"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-law-enforcement"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-militry"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-profession"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-security-uniforms"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-shop-by-product"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-sub-collection-listing"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-sub-collection-scrubs"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-tools"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-trafic-seafty"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-vehiclecabinetry"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
    jQuery(document).ready(function () {

        // This button will increment the value
        $('.btn.plus').click(function (e) {

            // Stop acting like a button
            e.preventDefault();
            // Get the field name
            fieldName = $(this).attr('field');
            // Get its current value
            var currentVal = parseInt($('input[name=' + fieldName + ']').val());
            // If is not undefined
            if (!isNaN(currentVal)) {
                // Increment
                $('input[name=' + fieldName + ']').val(currentVal + 1);
            } else {
                // Otherwise put a 0 there
                $('input[name=' + fieldName + ']').val(1);
            }
        });
        // This button will decrement the value till 0
        $(".btn.minus").click(function (e) {

            // Stop acting like a button
            e.preventDefault();
            // Get the field name
            fieldName = $(this).attr('field');
            // Get its current value
            var currentVal = parseInt($('input[name=' + fieldName + ']').val());
            // If it isn't undefined or its greater than 0
            if (!isNaN(currentVal) && currentVal > 1) {
                // Decrement one
                $('input[name=' + fieldName + ']').val(currentVal - 1);
            } else {
                // Otherwise put a 0 there
                $('input[name=' + fieldName + ']').val(1);
            }
        });

    });
$(document).ready(function() {

var firstValue = $(".color li:first-child").attr("data-value"); 
$('.color-name').text(firstValue);

$('.color .swatch-element').click(function () {
   var attri = $(this).attr("data-value"); 
   $('.color-name').text(attri);

});
jQuery('.swatch :radio').change(function() {

      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });

  if($('.product-single .bxslider').length > 0){	
    $('.product-single .bxslider').bxSlider({
      /*mode: 'vertical', 
      infiniteLoop: false,
      pager:false,
      slideWidth: 300,
      minSlides: 3,
      moveSlides: 1,
      slideMargin: 5  */

      mode: 'vertical',
      speed: 500,
      slideMargin:0,
      infiniteLoop: true, 
      pager: false, 
      controls: true, 
      slideWidth: 276, 
      minSlides: 3, 
      maxSlides:4, 
      moveSlides: 3, 
      adaptiveHeight: false
    });
  }

   
});


 $('.product-single__description h2').each(function(){ 
        var $set = $(this).nextUntil("h2");

        $set.wrapAll('<div class="panel" />');


      });

      $(".product-single__description h2").addClass('accordion');
      $('.panel').hide();

      $(".product-single__description.rte > .accordion:nth-child(1)").addClass('open').next('.panel').show();  
      $('.product-single__description .accordion').on('click', function(){
        // $('.panel').hide();
        //$('.accordion').removeClass('active');
        $(this).toggleClass('open');
        var isVisible = $(this).next().is(':visible');
        console.log(isVisible);
        if(isVisible == true){
          $(this).next().hide(1000);
        }else{
          $(this).next().show(1000);
        }
      });
 var wid = $(window).width();

               // console.log(wid);

                if(wid <= 749 )
                {
                  $('.product-single__thumbnails-product-template').removeClass('bxslider');
                    console.log(wid);

                }

    


               



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
$(".related-prod").owlCarousel({
        
        margin:0,
        nav:true,
        dots:false,
       responsive:{
            0:{
                items:1
            },
            640:{
                items:2
            },
            991:{
                items:3
            },
             1280:{
                items:4
            }
        }
        
      });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smith"] && !Shopify.designMode) return;
  try {
    



 
	
  /*  var parentss = $('li.activemainparent').parent();
    var parenttag = $('li.activecolor').parent();

    parent.addClass('activeul');
    parentss.addClass('activeul');
    parenttag.addClass('activeul');

    var find1 = $('ul.activeul').parent();
    find1.addClass('activemainparent');
    //console.log(find1);

     $('li.activemainparent h5.filter-title').on('click', function() {
      $('li.activemainparent ul.nav').removeClass('activeul');
      $('li.activemainparent ul.nav').addClass('activeul');
    //$('li.activemainparent ul.nav).toggleClass('activeclassblock');
    });
    */

     $('h5.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    }); 

	  var parent = $('li.site-nav--active').parent();
		parent.addClass('activesub');	
	parent.prev().addClass("activeclassplus");
	
	//console.log(parent);  
 
/*
  $('li a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });

 /*$('.main-parent > a.filter-title').on('click', function() {
     $(this).toggleClass('activeclassplus');
    $(this).next().toggleClass('activeclassblock');
    });
*/

      $(function () {
        $('.toggle-filters').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.mfp-close', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

 


  } catch(e) { console.error(e); }
})();
})();
